import { useState, useEffect, useMemo } from 'react'
import { subscribeToClubsPendingSubmissions } from '../services/firebase/submissions'

interface ClubNotifications {
  pendingCounts: { [clubId: string]: number }
  totalPendingCount: number
  isLoading: boolean
}

export const useClubNotifications = (adminClubIds: string[]): ClubNotifications => {
  const [pendingCounts, setPendingCounts] = useState<{ [clubId: string]: number }>({})
  const [isLoading, setIsLoading] = useState(true)

  // Calculate total pending count
  const totalPendingCount = useMemo(() => {
    return Object.values(pendingCounts).reduce((sum, count) => sum + count, 0)
  }, [pendingCounts])

  useEffect(() => {
    if (adminClubIds.length === 0) {
      setPendingCounts({})
      setIsLoading(false)
      return
    }

    setIsLoading(true)

    // Subscribe to real-time updates
    const unsubscribe = subscribeToClubsPendingSubmissions(
      adminClubIds,
      (counts) => {
        setPendingCounts(counts)
        setIsLoading(false)
      }
    )

    // Cleanup subscription on unmount or when clubs change
    return () => {
      unsubscribe()
    }
  }, [adminClubIds.join(',')]) // Use joined string to prevent unnecessary re-subscriptions

  return {
    pendingCounts,
    totalPendingCount,
    isLoading
  }
}